import React from 'react';
import Icon from "antd/lib/icon";

// util error handling is not designed, redirect all errors here for the time being

export function ErrorSink({message}) {

  if (!message) {
    return null;
  }

  return <div>
    <Icon type="warning" style={{color: '#FF9900'}}/>
    {message}
  </div>

}

export function errorSink(message, key) {
  return <ErrorSink key={key} message={message} />
}